/** Approved event values. Offsets differ after the November DST change. */
export const SYRE_OCTOBER_EVENT = {
  presentationUrl: "https://docs.google.com/presentation/d/1eOq9BpaT2tqYZidlLXscV3BILIjp7whAwsHcM8HJOLo/edit?usp=sharing",
  bonusClosesAt: "2026-10-26T03:59:00.000Z",
  closesAt: "2026-11-01T03:59:00.000Z",
  qaClosesAt: "2026-11-01T03:59:00.000Z",
  refundFloorAt: "2026-12-01T04:59:00.000Z",
  promotionLabel: "Weekend lock bonus",
  eventTerms: "SYRE October 2026: $100 value per reserved lock; estimated Q2 2027 shipping. If not shipped by September 30, 2027, $100 PadPulse account credit per undelivered lock, no cash value. Refunded purchases lose their contribution. Private Slack onboarding within one business day of payment. Refundable until the later of payment plus 30 days or November 30, 2026 at 11:59 PM ET.",
};

export function eventRefundUntil(paidAt: Date, floor?: string | null): Date {
  return new Date(Math.max(paidAt.getTime() + 30 * 86_400_000, floor ? new Date(floor).getTime() || 0 : 0));
}

export function retainedLockCount(purchases: Array<{ creditedAllowance: number; bonusAllowance: number; refundedAt: unknown; reviewReason?: string | null }>): number {
  const kept = purchases.filter((p) => !p.refundedAt);
  return Math.max(Math.floor(kept.reduce((n, p) => n + p.creditedAllowance, 0) / 5), kept.reduce((n, p) => n + p.bonusAllowance, 0));
}
